/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import Header from '@salesforce/retail-react-app/app/theme/components/project/header'

Header.baseStyle = {
    ...Header.baseStyle,
    container: {
        ...Header.baseStyle.container,
        height: '60px',
        zIndex: 1,
        borderBottom: '0.5px solid',
        transition: 'all 0.3s ease',
        boxShadow: 'none',
        minWidth: 'auto',
        alignContent: 'center',
        padding: 0
    },
    content: {
        paddingTop: {base: 0, lg: 0},
        paddingBottom: {base: 0, lg: 0},
        height: '60px',
        paddingLeft: {base: '12px', lg: '60px', xl: '60px'},
        paddingRight: {base: '12px', lg: '60px', xl: '60px'}
    },
    icons: {
        main: {
            margin: '10px',
            minWidth: 'auto',
            height: 'auto'
        },
        desktopBrandLogo: {
            width: '48px',
            minWidth: '48px',
            flex: '0 0 48px',
            marginLeft: '0rem',
            variant: 'unstyled',
            display: {base: 'none', md: 'none', lg: 'flex'},
            alignItems: 'center',
            justifyContent: 'center'
        },
        mobileBrandLogo: {
            height: '40px',
            width: '40px',
            minWidth: '40px',
            padding: '0',
            margin: 0,
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
            variant: 'unstyled',
            display: {base: 'block', md: 'block', lg: 'none'}
        },
        mobileSearchLogo: {
            variant: 'unstyled',
            display: {lg: 'none'}
        }
    },
    wrapper: {
        display: 'block',
        width: '100%',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        padding: {base: '0.25rem 1rem 0 1rem', lg: '0rem 1rem 0 1rem'}
    },
    searchWrapper: {
        width: {base: '93%', md: '93%', lg: '100%'},
        display: 'inline-block',
        verticalAlign: 'middle'
    },
    inputGroup: {
        alignItems: {base: 'flex-end', md: 'flex-end', lg: 'normal'},
        flexDirection: {base: 'row-reverse', md: 'row-reverse', lg: 'row'},
        sx: {
            '& input::placeholder': {
                fontWeight: '400',
                fontSize: '14px !important'
            }
        }
    },
    iconsWrapper: {
        wrap: {base: 'nowrap', lg: 'wrap'},
        alignItems: 'center',
        marginLeft: {md: '0rem'},
        position: {base: 'relative', lg: 'static'},
        width: '100%',
        height: '60px',
        sx: {
            '@media (max-width: 61.999em)': {
                '.header-icon-button svg': {
                    transition: 'color 180ms ease, fill 180ms ease, stroke 180ms ease'
                },
                '.hamburger-icon': {
                    margin: 0,
                    minWidth: '40px',
                    height: '44px'
                },
                '.open-search-mobile': {minWidth: '40px', height: '44px'},
                '.my-account-logo': {
                    marginLeft: 'auto',
                    minWidth: '40px',
                    height: '44px'
                },
                '.basket-icon': {minWidth: '40px', height: '44px', padding: '8px'},
                '.pd-icon': {minWidth: '40px', height: '44px'}
            },
            '@media (prefers-reduced-motion: reduce)': {
                '.header-icon-button svg': {transition: 'none'}
            }
        }
    },
    searchMenu: {
        overflowY: 'scroll',
        position: 'fixed',
        padding: ' 1rem 0',
        top: 0,
        height: {base: '100vh', md: '100vh'},
        zIndex: 10,
        bg: 'white',
        boxShadow: 'lg',
        display: {base: 'block', md: 'block', lg: 'none'},
        transition: 'left .5s cubic-bezier(0,1,.5,1), backdrop-filter 0.3s ease'
    },
    iconButton: {
        variant: 'unstyled',
        width: 'fit-content',
        height: '36px',
        minWidth: 'auto',
        minHeight: 'auto',
        ml: 2
    },
    inputWrapper: {
        verticalAlign: 'middle',
        position: 'absolute',
        right: {base: '19px', md: '1rem', lg: '3rem', xl: '4rem'}
    },
    popover: {
        arrowSize: 15,
        display: {lg: 'none'}
    },
    menu: {
        display: {lg: 'none'},
        variant: 'unstyled'
    },
    input: {
        autoComplete: 'off',
        borderColor: 'transparent',
        sx: {
            '::-webkit-search-cancel-button': {
                display: 'none'
            },
            '::-moz-search-cancel-button': {
                display: 'none'
            }
        },
        height: '36px',
        color: 'black.300',
        fontWeight: '500',
        fontSize: '16px',
        type: 'search',
        autoFocus: false,
        variant: 'filled',
        _hover: {
            borderColor: '1px solid transparent'
        },
        _focus: {
            borderColor: '1px solid transparent'
        },
        _focusVisible: {
            borderColor: '1px solid transparent'
        }
    },
    suggestions: {
        position: {lg: 'absolute'},
        top: {lg: '3.75rem'},
        left: {lg: '50%'},
        maxWidth: {lg: '100vw'},
        width: {lg: '100%'},
        transform: {lg: 'translateX(-50%)'}
    },
    accessibilityLinkWrapper: {
        position: 'absolute',
        top: {xxxs: '10px', base: '5px', lg: '15px'},
        right: {base: '15px', lg: '60px'},
        fontSize: '12px',
        fontWeight: '300',
        fontFamily: 'body',
        color: 'white'
    }
}
export default Header
